var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_289_85)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54 0.290039H6C2.68629 0.290039 0 2.97633 0 6.29004V54.29C0 57.6037 2.68629 60.29 6 60.29H54C57.3137 60.29 60 57.6037 60 54.29V6.29004C60 2.97633 57.3137 0.290039 54 0.290039Z",
    fill: "#513DE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 15.29L40.956 17.7247C41.5653 17.8607 42 18.4007 42 19.026V32.342C42 35.0167 40.6627 37.5153 38.4373 38.998L30 44.6233L21.5627 38.998C19.336 37.514 18 35.0167 18 32.3433V19.026C18 18.4007 18.4347 17.8607 19.044 17.7247L30 15.29ZM35.936 24.9193L29.336 31.518L25.5653 27.7473L23.68 29.6327L29.3373 35.29L37.8227 26.8047L35.936 24.9193Z",
    fill: "#086AD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_289_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.290039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListItem);
export default __webpack_public_path__ + "static/media/List_Item.a056ebffeee07762c9beb126881f73b6.svg";
export { ForwardRef as ReactComponent };